var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_14971_116163",
    maskUnits: "userSpaceOnUse",
    x: -0.00000124323,
    y: 0.364258,
    width: 11,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.00000124323,
    y: 0.364258,
    width: 11,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18209 7.33866L2.84356 2.00015L2 2.84371L7.33853 8.18223L2.00009 13.5207L2.84365 14.3643L9.02814 8.17974L8.18458 7.33617L8.18209 7.33866Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18209 7.33866L2.84356 2.00015L2 2.84371L7.33853 8.18223L2.00009 13.5207L2.84365 14.3643L9.02814 8.17974L8.18458 7.33617L8.18209 7.33866Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84356 2.00015L3.55067 1.29304L2.84356 0.585942L2.13646 1.29304L2.84356 2.00015ZM8.18209 7.33866L7.47499 8.04577L8.18257 8.75335L8.88968 8.04529L8.18209 7.33866ZM2 2.84371L1.29289 2.1366L0.585783 2.84371L1.29289 3.55082L2 2.84371ZM7.33853 8.18223L8.04564 8.88933L8.75274 8.18223L8.04564 7.47512L7.33853 8.18223ZM2.00009 13.5207L1.29298 12.8136L0.585882 13.5207L1.29298 14.2278L2.00009 13.5207ZM2.84365 14.3643L2.13654 15.0714L2.84365 15.7785L3.55076 15.0714L2.84365 14.3643ZM9.02814 8.17974L9.73525 8.88685L10.4423 8.17974L9.73525 7.47264L9.02814 8.17974ZM8.18458 7.33617L8.89169 6.62907L8.18411 5.92148L7.477 6.62954L8.18458 7.33617ZM2.13646 2.70726L7.47499 8.04577L8.8892 6.63155L3.55067 1.29304L2.13646 2.70726ZM2.7071 3.55082L3.55067 2.70726L2.13646 1.29304L1.29289 2.1366L2.7071 3.55082ZM8.04564 7.47512L2.7071 2.1366L1.29289 3.55082L6.63143 8.88934L8.04564 7.47512ZM2.7072 14.2278L8.04564 8.88933L6.63142 7.47512L1.29298 12.8136L2.7072 14.2278ZM3.55076 13.6572L2.7072 12.8136L1.29298 14.2278L2.13654 15.0714L3.55076 13.6572ZM8.32103 7.47264L2.13654 13.6572L3.55076 15.0714L9.73525 8.88685L8.32103 7.47264ZM7.47747 8.04328L8.32103 8.88684L9.73525 7.47264L8.89169 6.62907L7.47747 8.04328ZM8.88968 8.04529L8.89216 8.04281L7.477 6.62954L7.47451 6.63203L8.88968 8.04529Z",
    fill: "#383838",
    mask: "url(#path-1-outside-1_14971_116163)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPhoto);
export default __webpack_public_path__ + "static/media/nextPhoto.e7aaf12787b9ec5517d19e819f64f43d.svg";
export { ForwardRef as ReactComponent };